<template>
  <div class="condition-report-requests-list tab-table p-2">
    <condition-report-requests-table :inventory="inventory"
                             change-permission="change_condition_report_request"
                             delete-permission="delete_condition_report_request"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ConditionReportRequestsTable from "@/modules/condition-report-requests/ConditionReportRequestsTable.vue";

  const {mapState} = createNamespacedHelpers('inventory');
  const {mapActions} = createNamespacedHelpers('conditionReportRequests');

  export default {
    name: "InventoryConditionReportRequests",
    components: {ConditionReportRequestsTable},
    computed: {
      ...mapState({
        inventory: state => state.view.currentInventory,
      }),
    },
    methods: {
      ...mapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'inventory',
        extraFilters: {inventory_uuid: this.inventory.uuid}
      });
    }
  }
</script>

<style scoped>
</style>
